
        import 'SamplePlanLink.13f4c98.css-module'
        export default {"SamplePlanLink":"SamplePlanLink_SamplePlanLink_13f4c98","disabled":"disabled_SamplePlanLink_13f4c98","pulse":"pulse_SamplePlanLink_13f4c98"}
    